
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import PerfilControl from '@/components/PerfilControl.vue'
import PronosticoMeteorologicoControl from '@/components/PronosticoMeteorologicoControl.vue'
import PronosticoLocalMapasControl from '@/components/PronosticoLocalMapasControl.vue'
import ImagenesSatelitalesControl from '@/components/ImagenesSatelitalesControl.vue'
import EstacionesControl from '@/components/EstacionesControl.vue'
import PronosticoHidricoControl from '@/components/PronosticoHidricoControl.vue'
import PuntosPeligroControl from '@/components/PuntosPeligroControl.vue'
import MapaPeligroControl from '@/components/MapaPeligroControl.vue'
import { getEnvironments } from '@/environments'

const {
  settings:
    {
      PRONOSTICO_HIDRICO,
      PELIGRO, PUNTOS_PELIGRO,
      PRONOSTICO_METEOROLOGICO,
      ESTACIONES,
      PRONOSTICO_LOCAL
    }
} = getEnvironments()
const ACCOUNT_MODULE = 'account'

  @Component({
    components: {
      PerfilControl,
      PronosticoMeteorologicoControl,
      PronosticoLocalMapasControl,
      ImagenesSatelitalesControl,
      EstacionesControl,
      PronosticoHidricoControl,
      PuntosPeligroControl,
      MapaPeligroControl
    }
  })
export default class DesktopCustomControl extends Vue {
    @Action('logout', { namespace: ACCOUNT_MODULE })
    private logout!: any
    @Getter('token', { namespace: ACCOUNT_MODULE })
    private token!: any

    private pronosticoHidricoConfs = PRONOSTICO_HIDRICO

    private peligroConfs = PELIGRO
    private puntosPeligroConfs = PUNTOS_PELIGRO
    private pronosticoMeteorologicoConfs = PRONOSTICO_METEOROLOGICO
    private monitoreoConfs = ESTACIONES
    private pronosticoLocalConfs = PRONOSTICO_LOCAL

    descriptionShown: boolean = false;
    chevronLeft: string = 'img/icons/icon-chevron-circle-left.svg'
    chevronRight: string = 'img/icons/icon-chevron-circle-right.svg'

    openMenu: string[] = [
      'pronostico-hidrico',
      'pronostico-meteorologico',
      'pronostico-local',
      'imagenes-satelitales',
      'estaciones',
      'peligro'
    ]

    changeDescriptionValue (value: boolean) {
      this.descriptionShown = value
      return value
    }

    toggleDescriptions (isDescriptionShown: boolean): boolean {
      return this.changeDescriptionValue(!isDescriptionShown)
    }

    changeDescriptionShown (type: string) {
      this.changeDescriptionValue(this.shouldDescriptionShown(type))
    }

    async handleLogout () {
      await this.logout()
      this.$router.push('/ingresar')
    }

    shouldDescriptionShown (type: string) {
      if (this.openMenu.find(e => e === type)) {
        return true
      }
      return false
    }

    getArrowCircle (isDescriptionShown: boolean): string {
      return isDescriptionShown ? this.chevronLeft : this.chevronRight
    }

    get isDescriptionShown () {
      return this.descriptionShown
    }

    created () {
      const path = this.$route.path.substring(1)
      this.changeDescriptionShown(path)
      Vue.preGroup({
        document: [this.chevronLeft, this.chevronRight]
      }, 'prefetch')
    }
}
